import { makeStyles } from "@material-ui/core/styles";


const actionsTopButtonStyles = makeStyles(theme => ({
  actionsTopButtons: {
    border: '1px solid',
    marginRight: '0.5em',
    marginTop: '0.5em',
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
    '&:hover':{
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
  },  
  actionsTopButtonsSelected:{
    backgroundColor: theme.palette.primary.main,
    color: 'white',
  },
  saveAction: {
    width: "100%",
    justifyContent: "flex-end"
  },
  saveActionLeft: {
    width: "100%",
    justifyContent: "flex-start"
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(180deg)",
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    border: null,
    '&:hover':{
      backgroundColor: 'white',
      color: theme.palette.primary.main,
    },
  }
}));



export default actionsTopButtonStyles;
